import _slicedToArray from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  margin-left: ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-grow: 1;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  margin-top: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  flex-direction: column;\n  justify-content: center;\n  padding-top: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  margin: 0 auto;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  padding: ", " ", ";\n  text-align: center;\n  width: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useState } from 'react';
import styled from 'styled-components';
import { Button } from '@scp/ui-shared/components/buttons';
import { Carousel, CarouselItem } from '@scp/ui-shared/components/carousel';
import { Heading1, Paragraph } from '@scp/ui-shared/components/typography';
import { Spacing } from '@scp/ui-shared/components/layout';
import { baselineToRem } from '@scp/ui-shared/theme/utils';
import { Modal } from './Modal';
var TEXT = {
  DEFAULT_NEXT_BUTTON_LABEL: 'Next',
  DEFAULT_FINISH_BUTTON_LABEL: 'Get Started'
};
var StyledModal = styled(Modal)(_templateObject(), baselineToRem(10), baselineToRem(22), baselineToRem(125));
var LogoWrapper = styled.article(_templateObject2());
var Content = styled.article(_templateObject3(), baselineToRem(10));
var Actions = styled.footer(_templateObject4(), baselineToRem(3));
var ButtonWrapper = styled.article(_templateObject5());
var StyledButton = styled(Button).attrs({
  fullWidth: true
})(_templateObject6(), function (props) {
  return props.marginLeft ? baselineToRem(6) : 0;
});
export var WelcomeModal = function WelcomeModal(_ref) {
  var _ref$open = _ref.open,
      open = _ref$open === void 0 ? false : _ref$open,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? function () {
    return null;
  } : _ref$onClose,
      _ref$cards = _ref.cards,
      cards = _ref$cards === void 0 ? [] : _ref$cards,
      logo = _ref.logo,
      _ref$nextButtonLabel = _ref.nextButtonLabel,
      nextButtonLabel = _ref$nextButtonLabel === void 0 ? TEXT.DEFAULT_NEXT_BUTTON_LABEL : _ref$nextButtonLabel,
      _ref$finishButtonLabe = _ref.finishButtonLabel,
      finishButtonLabel = _ref$finishButtonLabe === void 0 ? TEXT.DEFAULT_FINISH_BUTTON_LABEL : _ref$finishButtonLabe;

  var _useState = useState(1),
      _useState2 = _slicedToArray(_useState, 2),
      activeCard = _useState2[0],
      setActiveCard = _useState2[1];

  var changeCard = function changeCard(card) {
    return setActiveCard(card);
  };

  var goToNextCard = function goToNextCard() {
    return changeCard(activeCard + 1);
  };

  var cardsCount = cards.length;
  var isLastCard = activeCard === cardsCount;
  if (!cards.length) return null;
  return React.createElement(StyledModal, {
    open: open,
    scrollable: false,
    noPaperPadding: true
  }, React.createElement(LogoWrapper, null, logo), React.createElement(Content, null, React.createElement("div", null, React.createElement(Carousel, {
    onChangePage: changeCard,
    activePage: activeCard
  }, cards.map(function (card) {
    return React.createElement(CarouselItem, {
      id: card.id,
      key: card.id
    }, React.createElement(Spacing, {
      marginBottom: 4
    }, React.createElement(Heading1, null, card.title)), React.createElement(Spacing, {
      marginBottom: 4
    }, React.createElement(Paragraph, {
      secondary: true
    }, card.description)));
  }))), React.createElement(Actions, null, !isLastCard ? React.createElement(ButtonWrapper, null, React.createElement(StyledButton, {
    title: finishButtonLabel,
    onClick: onClose,
    secondary: true
  }, finishButtonLabel), React.createElement(StyledButton, {
    title: nextButtonLabel,
    onClick: goToNextCard,
    marginLeft: true
  }, nextButtonLabel)) : React.createElement(StyledButton, {
    title: finishButtonLabel,
    onClick: onClose
  }, finishButtonLabel))));
};